function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSltsnowDirectoryIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 62 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29062,0,0,1.19042,-2.02516,-1.23555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.968,32.974L14.188,27.494L21.031,33.076L21.067,46.142L7.08,46.093L6.968,32.974Z",
    style: {
      fill: "none",
      stroke: "rgb(38,38,38)",
      strokeWidth: "2.15px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03266,0,0,0.92025,2.01207,11.1726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.106,44.939L11.09,40.867L16.13,40.917L16.104,45.043",
    style: {
      fill: "none",
      stroke: "rgb(38,38,38)",
      strokeWidth: "2.04px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.39342,0,0,1.22213,25.9939,-2.40284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.968,32.974L14.188,27.494L21.031,33.076L21.067,46.142L7.08,46.093L6.968,32.974Z",
    style: {
      fill: "none",
      stroke: "rgb(38,38,38)",
      strokeWidth: "2.03px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12031,0,0,1.06797,30.2793,4.75923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.106,44.939L11.09,40.867L16.13,40.917L16.104,45.043",
    style: {
      fill: "none",
      stroke: "rgb(38,38,38)",
      strokeWidth: "1.83px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.40767,0,0,1.06485,11.6219,-22.7659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.968,32.974L14.188,27.494L21.031,33.076L21.067,46.142L7.08,46.093L6.968,32.974Z",
    style: {
      fill: "none",
      stroke: "rgb(38,38,38)",
      strokeWidth: "2.14px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.49656,0,0,1.00894,11.0827,-19.9524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.106,44.939L11.09,40.867L16.13,40.917L16.104,45.043",
    style: {
      fill: "none",
      stroke: "rgb(38,38,38)",
      strokeWidth: "1.57px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSltsnowDirectoryIconSelected);
export default __webpack_public_path__ + "static/media/sltsnow_directory_icon_selected.b99d497d1a4098cccdf8d2120f7be2c4.svg";
export { ForwardRef as ReactComponent };